import React from "react";
import { useHistory } from "react-router-dom";

function HerdSection() {
  const history = useHistory();
  return (
    <div className="HerdSection" id="join">
      <div className="overlay">
        <div className="herdInfo">
          <h1 className="sectionHeading">
            Join the
            <span> unstoppable </span>
            herd
          </h1>
          <p className="para">
            You are so early! Become part of one of the most promising NFT
            projects in the industry.
          </p>
          <a
            href="https://solsurvivorsnft.com/"
            className="btn"
           
          >
            {/* <i className="far fa-paper-plane"></i> */}
            MINT NOW
          </a>
        </div>
      </div>
    </div>
  );
}

export default HerdSection;
